import React from 'react';
import ColorFillField from './ColorFillField';

function Field({ label, children }) {
  return (
    <label className="block space-y-1.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}

export default function TextComponentEffectFields({ props, setProp }) {
  return (
    <div className="rounded-lg border border-border p-3 space-y-4 bg-muted/10">
      <p className="text-xs font-semibold text-foreground">Effets visuels sur le texte</p>

      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={props.textOutlineEnabled === true}
          onChange={(e) => setProp('textOutlineEnabled', e.target.checked)}
        />
        <span className="text-sm flex-1 space-y-2">
          <span className="font-medium text-foreground block">Contour (ligne autour du texte)</span>
          {props.textOutlineEnabled ? (
            <>
              <Field label="Épaisseur (px)">
                <input
                  type="range"
                  min={0.5}
                  max={4}
                  step={0.5}
                  className="w-full"
                  value={props.textOutlineWidth ?? 1}
                  onChange={(e) => setProp('textOutlineWidth', Number(e.target.value))}
                />
              </Field>
              <ColorFillField
                label="Couleur du contour"
                value={props.textOutlineColor}
                onChange={(fill) => setProp('textOutlineColor', fill)}
                fallback="#1e293b"
              />
            </>
          ) : (
            <span className="text-xs text-muted-foreground block">
              Idéal pour lire un titre sur une photo.
            </span>
          )}
        </span>
      </label>

      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={props.textHoverShadowEnabled === true}
          onChange={(e) => setProp('textHoverShadowEnabled', e.target.checked)}
        />
        <span className="text-sm flex-1 space-y-2">
          <span className="font-medium text-foreground block">Ombre au survol</span>
          {props.textHoverShadowEnabled ? (
            <>
              <Field label="Flou de l&apos;ombre">
                <input
                  type="range"
                  min={0}
                  max={32}
                  step={1}
                  className="w-full"
                  value={props.textHoverShadowBlur ?? 14}
                  onChange={(e) => setProp('textHoverShadowBlur', Number(e.target.value))}
                />
              </Field>
              <Field label="Décalage vertical">
                <input
                  type="range"
                  min={0}
                  max={16}
                  step={1}
                  className="w-full"
                  value={props.textHoverShadowOffsetY ?? 4}
                  onChange={(e) => setProp('textHoverShadowOffsetY', Number(e.target.value))}
                />
              </Field>
              <ColorFillField
                label="Couleur de l&apos;ombre"
                value={props.textHoverShadowColor}
                onChange={(fill) => setProp('textHoverShadowColor', fill)}
                fallback="rgba(0,0,0,0.4)"
              />
            </>
          ) : (
            <span className="text-xs text-muted-foreground block">
              L&apos;ombre apparaît quand le visiteur passe la souris sur le bloc.
            </span>
          )}
        </span>
      </label>

      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={props.textShadowEnabled === true}
          onChange={(e) => setProp('textShadowEnabled', e.target.checked)}
        />
        <span className="text-sm flex-1 space-y-2">
          <span className="font-medium text-foreground block">Ombre permanente (optionnel)</span>
          {props.textShadowEnabled ? (
            <>
              <Field label="Flou">
                <input
                  type="range"
                  min={0}
                  max={24}
                  step={1}
                  className="w-full"
                  value={props.textShadowBlur ?? 8}
                  onChange={(e) => setProp('textShadowBlur', Number(e.target.value))}
                />
              </Field>
              <ColorFillField
                label="Couleur de l&apos;ombre"
                value={props.textShadowColor}
                onChange={(fill) => setProp('textShadowColor', fill)}
                fallback="rgba(0,0,0,0.25)"
              />
            </>
          ) : null}
        </span>
      </label>
    </div>
  );
}
